export class Prestation {
    public id: number;
    public nom: string;
    public tarif: number;
    public categorie_id: number;
    public taille: string;

    constructor(tab:any = {}){
      Object.assign(this, tab);
    }

    public get display(){
      return this.nom+" "+this.taille;
    }
}
